export const SENSOR_STATUSES = {
  NORMAL: 'Monitoring - NO AI Status.',
  CAUTION:
    'Watchlist - This component has been placed on the internal Waites Watchlist, and is being evaluated to determine whether additional action is required.',
  WARNING:
    'Action List - This component requires action. Please see Action Item description for more detail.',
  DETACHED: 'Detached - This sensor is currently not attached to the equipment',
};
